import { put, takeEvery } from '@redux-saga/core/effects';
import { matchMqttTopic } from 'store/mqtt/listeners/utils';
import { drmStart, drmProgress, drmEnd, drmError } from 'store/video/drm/slice';
import { cuttingReset } from 'store/video/cutting/actions';

type DrmMqttSagaPayload = {
    type: string;
    data: { progress?: number; error?: string };
};

function* drmMqttSaga(payload: DrmMqttSagaPayload) {
    const { type, data } = payload;
    const [, , provider, id, , action] = type.split('/');
    const assetId = Number(id);

    switch (action) {
        case 'start':
            yield put(drmStart({ provider, id: assetId }));
            break;
        case 'progress':
            yield put(drmProgress({ provider, id: assetId, progress: data.progress ?? 0 }));
            break;
        case 'end':
            yield put(drmEnd({ provider, id: assetId }));
            yield put(cuttingReset(provider, assetId));
            break;
        case 'error':
            yield put(drmError({ provider, id: assetId, error: data.error ?? 'unknown error' }));
            break;
        default:
    }
}

export default [takeEvery((action) => matchMqttTopic(action, 'drm', 4), drmMqttSaga)];
